<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container
    [observables]="[burdens$, contracts$]"
></ef-loading-container>

<ef-burden-filters-container
    [contracts]="allcontracts$ | async"
    (SelectContract)="onSelectContract($event)"
    (ToggleDetails)="onToggleDetails($event)"
></ef-burden-filters-container>
<ef-burden-presenter
    [loadClone]="LoadCloneSubject.asObservable() | async"
    [burdens]="burdens$ | async"
    [loading]="BurdenModelDS.loading$ | async"
    [cols]="cols"
    [colGroups]="colGroups"
    [contracts]="contracts$ | async"
    [chargeNumbers]="chargeNumbers$ | async"
    [contractTypes]="contractTypes$ | async"
    [showDetails]="ToggleDetailsSubject.asObservable() | async"
    (SaveItem)="onSaveItem($event)"
></ef-burden-presenter>
